import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import BaseContainer from '../baseContainers/BaseContainer';
import moment from 'moment';
import { t } from 'i18next';
import BlockUi from '../components/waitPanel/BlockUi';
import Constants from '../utils/constants';
import { CustomMessages } from '../components/CustomMessages';
import PublicHolidaysService from '../services/PublicHolidaysService';
import PublicHolidayCreateDialog from './PublicHolidayCreateDialog';
import { YearCalendarGridComponent } from '../components/YearCalendarGridComponent';
import YesNoDialog from '../components/YesNoDialog';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';

const newRequestColor = '#1dcbb3';

class PublicHolidaysCalendarComponent extends BaseContainer {
    constructor(props) {
        super(props, new PublicHolidaysService());
        this.calendarRef = React.createRef();

        this.state = {
            dialogVisible: false,
            loading: true,
            activeIndex: 0,
            selectedMonth: '' + moment().startOf('month'),
            selectedYear: { enumValue: '' + new Date().getFullYear(), label: '' + new Date().getFullYear() },
            selectedYearr: undefined,
            yearOptions: [],
            events: [],
            eventsDates: [],
            numberOfMonths: 12,
            choosenDay: undefined,
            viewMode: 'NEW',

            element: {
                name: '',
                date: undefined,
                selectedYear: undefined,
            },
        };
        this.handleDateClick = this.handleDateClick.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
        this.getEvents();
        this.getYearOptions();
        this.readMessage();       
    }

    selectedYear = (value) => {
        this.setState(
            () => ({
                selectedYear: value,
            }),
            () => {
                this.goToYear(moment(value).year());
            }
        );
    };

    getYearOptions(eventsDates) {
        this.service.getYearOptions().then((res) => {
            this.setState({ yearOptions: res })
        })
    }

    goToYear(year) {
        this.refresh();
    }

    handleDateClick(rowData) {
        let dateFormatted = moment(rowData.value).format(Constants.DATE_JSON_FORMAT)
        this.setState({ dialogVisible: true, element: { date: dateFormatted } })
    }

    handleRemoveDate(date) {
        let formattedDate = moment(new Date(date.year, date.month, date.day)).format(Constants.DATE_GET_REQUEST_FORMAT);
        let event = this.state.events?.filter(e => moment(e.date).format(Constants.DATE_GET_REQUEST_FORMAT) === formattedDate)[0];
        this.setState({ confirmDialogVisible: true, removeEvent: event })
    }

    getEvents() {
        const { selectedMonth, selectedYear } = this.state;
        this.setState(
            {
                loading: true,
                // loading: false,
            },
            () => {
                this.service
                    .getEvents(selectedYear.enumValue)
                    .then((data) => {
                        const customColorData = data.map((element) => ({
                            ...element,
                            backgroundColor: newRequestColor,
                            start: element.date,
                            end: element.date,
                            description: element.name,
                        }));
                        let eventsdates = data.map(d => moment(d.date).format(Constants.DATE_GET_REQUEST_FORMAT));
                        this.setState({
                            events: customColorData,
                            eventsDates: eventsdates,
                            loading: false,
                        }
                        );
                    })
                    .catch(() => {
                        this.setState({
                            loading: false,
                        });
                        this.showErrorMessage(t('public-holidays.eventsError'));
                    });
            }
        );
    }

    refresh() {
        this.getEvents();

    }

    prepareHeaderItems() {
        return [];
    }

    prepareFooterItems() {
        return [];
    }

    translate(key) {
        const { t } = this.props;
        return t(key);
    }

    isHoliday(date) {
        const dateString = date; // Format: YYYY-MM-DD
        return this.state.eventsDates?.includes(dateString);
    };

    holidayTemplate = (date) => {
        return this.isHoliday(date) ? 'holiday' : '';
    };

    dateTemplate(date) {
        let mDate = moment(new Date(date.year, date.month, date.day)).format(Constants.DATE_GET_REQUEST_FORMAT);
        this.state.eventsDates?.includes(mDate)
        if (this.state.eventsDates?.includes(mDate) === true) {
            return (
                <div style={{ userSelect: 'none', backgroundColor: '#1dcbb3', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', padding: 0 }}>{date.day}</div>
            );
        }
        else {
            return date.day;
        }


    }
    afterObjectUpdate() {
        this.readMessage();        
        this.refresh();
        this.unblockUi();
    }


    onYearChange = (a, b, e) => {
        let value = e.value.enumValue;
        this.setState({
            selectedYear: { enumValue: e.value.enumValue, label: e.value.enumValue },
        }
            , this.selectedYear(value)
        )
    }


    handleDelete(e) {
        if (e) {
            e.preventDefault();
        }
        console.log('delete {}', this.state.removeEvent)
        this.service
            .remove(this.state.removeEvent)
            .then((response) => {
                this.blockUi();
                this.persistMessage('success', '', t('public-holidays.deleteSuccess'));
            })
            .catch((err) => {
                this.persistMessage('error', '', t('public-holidays.deleteError'));
            })
            .finally(() => {
                this.afterObjectUpdate();
                this.setState({ confirmDialogVisible: false });
            });

    }

    render() {
        return (
            <div className='public-holidays-daygridd'>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
                    <InputDropdownComponent
                        id={`selectedYear`}
                        name='selectedYear'
                        label={'Rok'}
                        value={this.state.selectedYear}
                        valueView={this.state.selectedYear !== undefined ? this.state.selectedYear?.label : this.state.selectedYear}
                        stateField={``}
                        style={{ width: '100px', marginBottom: '10px' }}
                        options={this.state.yearOptions}
                        optionLabel={'label'}
                        dataKey='enumValue'
                        onChange={this.onYearChange}
                        insideTable
                        viewMode={'EDIT'}
                        validators='required'
                    />
                    {
                        this.state.yearOptions?.map((el) => {
                            if ((this.state.selectedYear?.enumValue === parseInt(el.enumValue)) || (this.state.selectedYear?.enumValue === el.enumValue)) {
                                return (<div className='public-holidays-daygrid'>
                                    <YearCalendarGridComponent
                                        selectedYear={parseInt(el.enumValue)}
                                        eventsDates={this.state.eventsDates}
                                        events={this.state.events}
                                        openDialog={(rowdata) => this.handleDateClick(rowdata)}
                                        yesNoDialog={(e) => this.handleRemoveDate(e)}
                                    >
                                    </YearCalendarGridComponent>
                                </div>)
                            }

                        })
                    }

                    {this.state.dialogVisible ? (
                        <PublicHolidayCreateDialog
                            id='public-holiday-dialog'
                            className='car-dialog'
                            key={`new-public-holiday-dialog`}
                            element={this.state.element}
                            onHide={(e) => this.setState({ dialogVisible: false })}
                            visible={this.state.dialogVisible}
                            viewMode={'NEW'}
                            afterSave={(e) => {
                                this.setState({ dialogVisible: false });
                                this.afterObjectUpdate();
                            }}
                            blockUi={this.blockUi}
                            unblockUi={this.unblockUi}
                            _isMounted={this._isMounted}
                        />
                    ) : null}
                    {this.state.confirmDialogVisible ? (
                        <YesNoDialog
                            id={'activity-delete-confirmation-dialog'}
                            visible={this.state.confirmDialogVisible}
                            header={t('public-holidays.deleteHeader')}
                            name='visible'
                            onChange={(type, x, target) => {
                                if (target.value) {

                                    this.handleDelete();
                                } else {
                                    this.setState({ confirmDialogVisible: false })
                                }
                            }}
                            onHide={() => this.setState({ confirmDialogVisible: false })}
                        >
                            {t('public-holidays.deleteConfirmation')} <br></br>
                            {this.state.removeEvent?.date + ' - ' + this.state.removeEvent?.name + ' ?'}
                        </YesNoDialog>
                    ) : null}
                    <div className="card flex justify-content-center">

                    </div>

                </BlockUi>
            </div>
        );
    }


}

PublicHolidaysCalendarComponent.defaultProps = {
    viewMode: 'EDIT',
    newUrl: '/#/public-holiday/create',
    detailsUrl: '/#/public-holiday/details',
};

PublicHolidaysCalendarComponent.propTypes = {
    viewMode: PropTypes.string.isRequired,
};

export default withTranslation()(PublicHolidaysCalendarComponent);
